import React from "react";
import "../css/paysuccess.css";
import { Link, useLocation } from "react-router-dom";
import { FiArrowRight, FiCheck } from "react-icons/fi";
import { formatPrice } from "../config/siteConfig";

const PaySuccess = () => {
  const { state } = useLocation();
  const orderNumber = state?.orderNumber || "DOM-DEMO";

  return (
    <main className="payment-success app-page-enter">
      <div className="payment-success__mark"><FiCheck aria-hidden="true" /></div>
      <p className="eyebrow">Order confirmed / {orderNumber}</p>
      <h1>Great choice.<br />Your trousers are on their way.</h1>
      <p className="payment-success__intro">
        We hebben de orderbevestiging{state?.email ? ` naar ${state.email}` : " per e-mail"} gestuurd.
        Zodra je bestelling vertrekt, ontvang je een track & trace.
      </p>
      <dl>
        <div><dt>Order</dt><dd>{orderNumber}</dd></div>
        {state?.total && <div><dt>Total</dt><dd>{formatPrice(state.total)}</dd></div>}
        <div><dt>Status</dt><dd>Wordt voorbereid</dd></div>
      </dl>
      <div className="payment-success__actions">
        <Link className="solid-button" to="/shop" onClick={() => window.scrollTo({ top: 0 })}>
          Verder ontdekken <FiArrowRight aria-hidden="true" />
        </Link>
        <Link className="text-link" to="/contact">Vraag over je bestelling?</Link>
      </div>
      <div className="payment-success__note">
        <span>domtanion</span>
        <span>Everyday trousers</span>
        <span>Fit / Fabric / Detail</span>
      </div>
    </main>
  );
};

export default PaySuccess;
